// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-report-tsx": () => import("/opt/build/repo/src/templates/report.tsx" /* webpackChunkName: "component---src-templates-report-tsx" */),
  "component---src-pages-index-tsx": () => import("/opt/build/repo/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-reports-tsx": () => import("/opt/build/repo/src/pages/reports.tsx" /* webpackChunkName: "component---src-pages-reports-tsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

